import { render, staticRenderFns } from "./CustomerFirmwareDetails.vue?vue&type=template&id=2470da9b&scoped=true"
import script from "./CustomerFirmwareDetails.vue?vue&type=script&lang=js"
export * from "./CustomerFirmwareDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerFirmwareDetails.vue?vue&type=style&index=0&id=2470da9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470da9b",
  null
  
)

export default component.exports